import { Component } from '@angular/core';
import { BsModalRef } from 'ngx-bootstrap/modal';
import { take } from 'rxjs/operators';
import { ProjectManagementService } from '../services/project-management.service';
import { UserManagementService } from '../services/user-management.service';

@Component({
  selector: 'app-reject-project-assignment',
  templateUrl: './reject-project-assignment.component.html',
  styleUrls: ['./reject-project-assignment.component.scss']
})
export class RejectProjectAssignmentComponent {
  projectId!: string;
  projectName!: string;

  constructor(
    public modalRef: BsModalRef,
    private projectManagementService: ProjectManagementService,
    private userManagementService: UserManagementService
  ) {}

  async unassignProject() {
    const currentUser = await this.userManagementService.getUsername().pipe(take(1)).toPromise();
    await this.projectManagementService.unassignProject(this.projectId, currentUser ?? '');
    this.modalRef.hide();
  }
}
